import React from 'react';
import { Link } from 'react-router-dom';

const RegistrationSuccess = () => {
  return (
    <div style={styles.container}>
      <h1 style={styles.title}>Поздравляем с успешной регистрацией!</h1>
      <p style={styles.message}>
        Мы отправили на вашу электронную почту письмо с ссылкой для подтверждения. Пожалуйста, перейдите по
        ссылке, чтобы активировать вашу учетную запись.
      </p>
      <p style={styles.message}>Если письмо не пришло, проверьте папку "Спам".</p>
      <Link to="/user/login" style={styles.button}>Перейти к входу</Link>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: '600px',
    margin: '50px auto',
    padding: '20px',
    backgroundColor: '#fff',
    borderRadius: '8px',
    textAlign: 'center',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
  },
  title: {
    color: '#333',
  },
  message: {
    color: '#555',
  },
  button: {
    display: 'inline-block',
    padding: '10px 20px',
    backgroundColor: '#4CAF50',
    color: '#fff',
    textDecoration: 'none',
    borderRadius: '5px',
    marginTop: '20px',
  },
};

export default RegistrationSuccess;
